<app-company-list-component [page]="'search'"></app-company-list-component>
